<div class="notices-wrap">
  <app-notice-ui-notice-list-item
    [notice]="notice"
    (delete)="onDelete($event)"
    *ngFor="let notice of notices"
    class="notices-item"
  ></app-notice-ui-notice-list-item>
</div>
